import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Pipe, PipeTransform } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-deactivation',
    templateUrl: './deactivation.component.html',
    styleUrls: ['./deactivation.component.scss'],
    standalone: false
})
export class DeactivationComponent implements OnInit {
  countDown: Subscription;
  counter = 1200;
  tick = 1000;
  showOtherReason = false;
    deactivationReasonList: any[] = [];
    @Input() type: 'company' | 'vessel';
  @Input() public modalData: any;
  @Input() id: any;
  @Input() value: any;
  @Output() updateData = new EventEmitter();
  note: any;
  showThiredButton: boolean = false;
  reason: string = '';
roleForm: FormGroup;
submitted = false;
  constructor(public readonly activeModal: NgbActiveModal,
        private readonly toastr: ToastrService,
        private readonly apiService: ApiService,
        private readonly fb: FormBuilder
  ) {}

  ngOnInit(): void {


    this.roleForm= this.fb.group({
    deactivationReasonId: [null, Validators.required],
    otherDeactivationReason: [
      '',
      [
        Validators.maxLength(100),
        Validators.pattern(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ]+$/),
      ],
    ],
   
  });
    this.getList()
    this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
    if (this.modalData?.showThiredButton) {
      this.showThiredButton = this.modalData?.showThiredButton;
    }
    this.roleForm.get('deactivationReasonId')?.valueChanges.subscribe((value) => {
  const selectedReason = this.deactivationReasonList.find(
    (item) => item.id === value
  );

  this.showOtherReason =
    selectedReason?.value?.toLowerCase() === 'other';

  const otherReasonControl = this.roleForm.get('otherDeactivationReason');

  if (this.showOtherReason) {
    otherReasonControl?.setValidators([
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9 ]+$/),
    ]);
  } else {
    otherReasonControl?.clearValidators();
    otherReasonControl?.reset();
  }

  otherReasonControl?.updateValueAndValidity();
});
  }
 getList() {
  const ddlType =
    this.type === 'company'
      ? 'companyinactivereason'
      : 'vesselinactivereason';

  this.apiService
    .getRequest(`/masters?DdlType=${ddlType}`, {}, true)
    .subscribe((res: any) => {
      this.deactivationReasonList = res?.data || [];
    });
}

  ngOnDestroy() {
    this.countDown.unsubscribe();
  }

 closeModal() {
    this.activeModal.close();
  }

onSubmit() {
  this.submitted = true;

  if (this.roleForm.invalid) {
    return;
  }

  const formValue = this.roleForm.value;

  let payload: any;

  if (this.type === 'company') {
    payload = {
      companyId: this.id,
      isActive: this.value === 'true' ? false : true,
      deactivationReasonId: formValue.deactivationReasonId,
      otherDeactivationReason: formValue.otherDeactivationReason
    };
  } else {
    payload = {
      vesselId: this.id,
      active: this.value === 'true' ? false : true,
      deactivationReasonId: formValue.deactivationReasonId,
      otherDeactivationReason: formValue.otherDeactivationReason
    };
  }

  const endpoint =
    this.type === 'company'
      ? '/company'
      : '/vessels';

  this.apiService
    .patchRequest(endpoint, payload)
    .subscribe((res: any) => {
      if(res?.status)
      {
        this.toastr.success(res?.message)
      }
      this.activeModal.close();
    });
}
}



